<template>
    <div class="w-screen min-w-[100vw] bg-gray-700 min-h-screen md:flex  ">

        <div class=" w-full relative bg-blend-color-burn    flex flex-col max-h-screen " :class="showContact ? 'lg:col-span-6' :'lg:col-span-9' "
        style="background-image: url('/bg.png');background-size: cover;  ">
            <div
        class="flex justify-between items-center w-full px-3 py-4 border-l-2 dark:bg-slate-800 bg-gray-200 border-l-white dark:border-l-gray-700 dark:text-gray-300">

        <div class="flex items-center">
            <img src="@/assets/user5.svg" v-if="!conversation?.profile || conversationIsLoading" alt=""
                class="w-10 h-10 p-2 mr-1 rounded-full  dark:bg-slate-950">
            <img :src="conversation?.profile" v-else alt=""
                class="w-10 h-10 p-2 mr-1 rounded-full  dark:bg-slate-950">
            <div class="" v-if="conversationIsLoading">
                <b> ... </b>
            </div>
            <div class="  py-2 flex items-center text-center justify-center text-red-950 dark:text-gray-500 "
                v-else-if="!conversationIsSuccess">

                <i class="las la-exclamation-triangle text-md   mr-1"></i>
                <div class=" font-bold  rounded-lg">
                    Impossible de charger cette conversation,Ressayez
                </div>
            </div>
            <div class="" v-else>
                <b>{{ conversation?.name ?? conversation?.chat_id?.split('@')[0] ?? ' ' }}</b>
                <div class="text-xs font-light dark:text-gray-200 text-gray-800" v-if="conversation?.name">{{
                    conversation?.chat_id?.split('@')[0]
                    ?? ' '}}</div>
            </div>
        </div>
        </div>
        <div class="flex-1  dark:bg-slate-800/75 flex flex-col justify-center items-center bg-gray-200/25 border-l-2 dark:border-l-gray-700 overflow-y-auto"
        v-if="messageIsLoading">
    </div>

    <div ref="messageContent"
        class="flex-1 relative dark:bg-slate-800/75 bg-gray-200/25 border-l-2 dark:border-l-gray-700 overflow-y-auto"
        v-else-if="messages.length">
       
            <LoadOldMessage v-if="pagination?.next_page_url" />
            <div class="w-fit right-9 z-30 bottom-20 absolute">
                <div  ref="scrollBtn"
                    class=" fixed w-fit p-1 rounded-full t bg-teal-900 text-white px-2  ">
                    <i class="las la-arrow-circle-down text-xl"></i>
                </div>
            </div>

            <MessageItem v-for="(message, i) in messages" :message="message" :key="i" />
    
    </div>

        </div>
    </div>
</template>
<script>
import  {mapActions }from "vuex"
import { mapFields } from 'vuex-map-fields';
import MessageItem from '@/pages/messages/components/MessageItem.vue';

import LoadOldMessage from '@/pages/messages/widgets/LoadOldMessage.vue';

export default {
    name:"ConversationShow",
    components:{
        MessageItem,
        LoadOldMessage
    },
    computed:{
        ...mapFields("conversations/show",{
            conversationIsLoading:"isLoading",
            conversationIsSuccess:"isSuccess",
            conversation:"item",
            conversationMessage:"message",
            conversationShowMessage:"showMessage",
            currentItem:"currentItem",
            filter:"filter"
             
        }),
        ...mapFields("messages/list",{
            messageIsLoading:"isLoading",
            messageIsSuccess:"isSuccess",
            messages:"items",
            messageMessage:"message",
            pagination:"pagination",
            messageShowMessage:"showMessage",
            messageFilter:"filter"
        }),
 
    },
        
    methods:{
        ...mapActions({getConversation:"conversations/show/getOne",
        resetConversation:"conversations/show/resetData",
       })
    },
    mounted(){
        const id = this.$route.params.id
        this.currentItem = {id}
        this.filter.conversation_id = id
        this.messageFilter.conversation_id = id
        this.getConversation()
    },
    beforeUnmount(){
        this.resetConversation()
    }
}
</script>